import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import Searchbar from './Searchbar';
const TopHeader = () => {
  return (
    <header className=' bg-colorOne  py-5 '>
      <div className='flex container mx-auto justify-between'>
        <Link
          className=''
          to='/'
        >
          <img
            src={logo}
            className='w-[80%] h-auto'
            alt=''
            loading='lazy'
          />
        </Link>
        <Searchbar />
      </div>
    </header>
  );
};

export default TopHeader;
